//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import modalMixin from '~/mixins/modal'

export default {
  name: 'AppMessages',

  mixins: [modalMixin],

  computed: {
    show() {
      return Boolean(this.message)
    },

    message() {
      return this.$store.state.ui.message
    }
  },

  methods: {
    close() {
      return this.$store.dispatch('ui/clearAppMessage')
    }
  }
}
